import React , {useState,useEffect} from 'react';
import Container from '../common/Container';
import axios  from 'axios';
import { Link } from 'react-router-dom';
const PopularProducts = () => {
const [products,ProductState] = useState([]);



 const getData =async () => {
    try {
     const response = await axios.get('https://fakestoreapi.com/products?limit=10');
   const res= await response.data;
   ProductState(res);   
    } catch (error) {
         console.log(error);      
    }
 }
         
 useEffect(() => {
   getData();
  }, []);

    return (
         <Container>
      <div className="mb-8 flex items-end justify-between gap-4">
        <div><p className="text-sm font-semibold uppercase tracking-widest text-indigo-600">Curated for you</p><h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">Popular right now</h2></div>
        <p className="hidden max-w-sm text-sm leading-6 text-slate-500 sm:block">A balanced mix of customer favourites, displayed in product-safe image frames.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {products.slice(0, 5).map((product, index) => (
          <Link key={product.id} to={`/product/${product.id}`} className={`group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg ${index === 0 ? 'sm:col-span-2 sm:row-span-2' : ''}`}>
            <div className={`${index === 0 ? 'h-80 sm:h-full sm:min-h-[440px]' : 'h-56'} bg-slate-50 p-6`}><img className="h-full w-full object-contain transition duration-300 group-hover:scale-105" src={product.image} alt={product.title} /></div>
            <div className="border-t border-slate-100 p-4"><p className="truncate text-sm font-semibold text-slate-800">{product.title}</p><p className="mt-1 text-sm text-indigo-600">${product.price}</p></div>
          </Link>
        ))}
      </div>
</Container>
      );
}
 
export default PopularProducts;
